import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/bond-yield-calculator',
  component: () => import('../../routes/BondYieldCalculator.svelte'),
  card: {
    id: 'bond-yield-calculator',
    title: 'Bond Yield (YTM)',
    description: 'Calculate the yield to maturity (YTM) and current yield for bonds held to maturity.',
    icon: 'account_balance',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/bond-yield-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Bond Yield Calculator – Yield to Maturity (YTM) Calculator',
    description:
      'Free bond yield calculator to calculate yield to maturity (YTM) and current yield. Understand your bond investments, coupon payments, and total returns at maturity.',
  },
};

export default meta;
